export default __webpack_public_path__ + "static/media/Brochure.56e3ae16.jpg";